import { render, staticRenderFns } from "./InfoInsured.vue?vue&type=template&id=072bdc5b&scoped=true"
import script from "./InfoInsured.vue?vue&type=script&lang=js"
export * from "./InfoInsured.vue?vue&type=script&lang=js"
import style0 from "./InfoInsured.vue?vue&type=style&index=0&id=072bdc5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bdc5b",
  null
  
)

/* custom blocks */
import block0 from "./InfoInsured.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports